import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signIn, resetAccount } from '../../store/actions/authActions';
import { openSignupModal } from '../../store/actions/signupModalActions';
import { Redirect } from 'react-router-dom';
import './SignIn.css';
import { withFirebase, withFirestore } from 'react-redux-firebase';
import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import PersonIcon from '@material-ui/icons/Person';
import Lock from '@material-ui/icons/Lock';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faStickerMule } from '@fortawesome/free-brands-svg-icons';
import Paper from '@material-ui/core/Paper';
import { RadioIcon, RadioFillIcon, white } from '../../style';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Dialog from '@material-ui/core/Dialog';
import '../../components/home/Home.css';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

const styles = theme => ({
  modalStyles: {
    display: 'flex'
  },
  submitButton: {
    margin: '0 auto',
    marginTop: '20px',
    color: white,
    padding: '10px 40px'
  },
  loadingSpinner: {
    position: 'absolute',
    top: '50%',
    right: '50%'
  },
  input: {
    margin: '10px 0',
    backgroundColor: white
  },
  checkbox: {
    margin: 0,
    marginLeft: -11
  },
  youtubeLoginButton: {
    backgroundColor: '#BD3027',
    width: '300px',
    color: 'white',
    height: '44px'
  },
  icon: {
    marginRight: '5px'
  },
  accountText: {
    marginTop: '10px'
  },
  error: {
    color: 'red'
  },
  forgotPwLink: {
    color: '#22c26e',
    cursor: 'pointer'
  },
  confirmResetButton: {
    color: 'white',
    backgroundColor: '#22c26e'
  },
  emailField: {
    marginTop: '25px',
    marginBottom: '25px',
    width: '300px'
  },
  resetContainer: {
    textAlign: 'center'
  },
  signuptext: {
    cursor: 'pointer'
  },
  viewStyle: {
    overflowX: 'hidden',
    overflowY: 'hidden'
  },
  checkboxContainer: {
    marginLeft: '2px'
  },
  form: {
    width: '100%'
  },
  headerContainer: {
    height: '100px'
  },
  logoImage: {
    cursor: 'pointer',
    marginLeft: '50px',
    border: 'none',
    display: 'block',
    backgroundImage: 'url(/images/text-blue-big.png)',
    width: '150px',
    height: '50px',
    overflow: 'visible',
    backgroundSize: '150px'
  },
  signinContainer: {
    maxWidth: '500px',
    margin: '0 auto',
    marginTop: '100px',
    marginBottom: '100px'
  }
});

class SignIn extends Component {
  state = {
    email: '',
    password: '',
    signInErrorText: '',
    tabValue: 0,
    currentIndex: 0,
    resetPasswordModalOpen: false,
    resetEmail: '',
    resetEmailErrorText: ''
  };

  componentDidMount() {
    if (this.props.auth.uid) {
      this.props.history.push('/about');
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.signIn(this.state);
  };

  handleGoogleSignIn = e => {
    e.preventDefault();
  };

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  redirectToHome = () => {
    this.props.history.push('/');
  };

  signInWithGoogle = async () => {
    const classRef = this;
    window.gapi.load('client:auth2', async function() {
      await window.gapi.auth2.init({
        client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/youtube.readonly'
      });

      const authInstance = await window.gapi.auth2.getAuthInstance();
      const authToken = await authInstance.signIn({
        prompt: 'select_account'
      });

      const googleUser = authInstance.currentUser.get();

      const email = googleUser.getBasicProfile().getEmail();

      // check if the user has any provider with this email address yet
      const providers = await classRef.props.firebase
        .auth()
        .fetchSignInMethodsForEmail(email);

      if (providers.length === 0) {
        // if no providers tell them to sign up
        classRef.setState({
          ...classRef.state,
          signInErrorText: 'Account not found. Please sign up.'
        });

        classRef.props.firebase.auth().signOut();
      } else {
        // if yes continue with login
        const googleIdToken = googleUser.getAuthResponse().id_token;
        const creds = classRef.props.firebase.auth.GoogleAuthProvider.credential(
          googleIdToken
        );

        await classRef.props.firebase.auth().signInWithCredential(creds);

        const idToken = await classRef.props.firebase
          .auth()
          .currentUser.getIdToken(true);

        const authRespose = await googleUser.reloadAuthResponse();
        // const authRespose = googleUser.getAuthResponse();
        const googleCreds = JSON.stringify({ ...authRespose });

        axios.post(
          `${process.env.REACT_APP_FIREBASE_URL}/saveUserGoogleCredentials`,
          {
            idToken,
            googleCreds
          }
        );
      }
    });
  };

  handleTabChange(event, newValue) {
    this.setState({
      tabValue: newValue
    });
  }

  handleChangeIndex(index) {
    this.setState({
      currentIndex: index
    });
  }

  openResetPasswordModal = () => {
    this.setState({
      resetPasswordModalOpen: true
    });
  };

  closeResetPasswordModal = () => {
    this.setState({
      resetPasswordModalOpen: false
    });
  };

  handleEmailChange = e => {
    this.setState({
      resetEmail: e.target.value
    });
  };

  sendResetPasswordEmail = () => {
    if (this.validateEmail(this.state.resetEmail)) {
      this.props.sendResetPasswordEmailHandler(this.state.resetEmail);
      this.setState({
        resetEmailErrorText: '',
        resetPasswordModalOpen: false
      });
    } else {
      this.setState({
        resetEmailErrorText: 'please enter a valid email'
      });
    }
  };

  handleOpenLoginModal = e => {
    e.preventDefault();
    this.props.openSignupModal();
  };

  render() {
    const { authError, auth, classes } = this.props;
    const { signInErrorText, tabValue, resetPasswordModalOpen } = this.state;
    if (auth.uid) return <Redirect to="/" />;
    return (
      <React.Fragment>
        <Grid container direction="column">
          <div className={classes.headerContainer}>
            <div
              className={classes.logoImage}
              onClick={() => this.redirectToHome()}
            ></div>
          </div>
          <Paper className={classes.signinContainer}>
            <Tabs
              value={tabValue}
              onChange={this.handleTabChange.bind(this)}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="Brand" />
              <Tab label="Influencer" />
            </Tabs>

            <Grid className="login-container">
              <Typography variant="h6" gutterBottom />
              <SwipeableViews
                index={tabValue}
                onChangeIndex={this.handleChangeIndex}
                className="login-container-2"
              >
                <Grid container spacing={24} className={classes.viewStyle}>
                  <form onSubmit={this.handleSubmit} className={classes.form}>
                    <Grid item xs={12}>
                      <TextField
                        className={classes.input}
                        variant="outlined"
                        required
                        id="email"
                        name="email"
                        placeholder="Login or Email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        type="email"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box color="text.hint">
                                <PersonIcon />
                              </Box>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        className={classes.input}
                        variant="outlined"
                        required
                        id="password"
                        name="password"
                        placeholder="Password"
                        type="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box color="text.hint">
                                <Lock />
                              </Box>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        spacing={1}
                      >
                        <Grid item className={classes.checkboxContainer}>
                          <FormControlLabel
                            className={classes.checkbox}
                            value="rememberme"
                            control={
                              <Checkbox
                                color="primary"
                                icon={<RadioIcon htmlColor={'#f0eded'} />}
                                checkedIcon={
                                  <RadioFillIcon htmlColor={'#f0eded'} />
                                }
                              />
                            }
                            label="Remember me"
                            labelPlacement="end"
                          />
                        </Grid>
                        <Grid
                          item
                          onClick={this.openResetPasswordModal.bind(this)}
                        >
                          <Typography className={classes.forgotPwLink}>
                            Forgot password
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="auth-error">{authError}</div>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.submitButton}
                        type="submit"
                      >
                        Login
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Box mt={2}>
                        <Grid
                          container
                          alignItems="center"
                          justify="center"
                          spacing={1}
                        >
                          <Grid item>
                            <Typography>Not a member? </Typography>
                          </Grid>
                          <Grid
                            item
                            onClick={this.handleOpenLoginModal.bind(this)}
                          >
                            <Typography
                              color="primary"
                              className={classes.signuptext}
                            >
                              Sign up
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </form>
                </Grid>
                <React.Fragment>
                  {/* <Typography className={classes.accountText}>
              <Box color="text.secondary">
                Or sign in with a different account
              </Box>
            </Typography> */}
                  <Box mt={4}>
                    <Button
                      className={classes.youtubeLoginButton}
                      onClick={this.signInWithGoogle}
                    >
                      <FontAwesomeIcon
                        className={classes.icon}
                        icon={faYoutube}
                      />
                      Login with Youtube
                    </Button>
                    <Typography className={classes.error}>
                      {signInErrorText}
                    </Typography>
                  </Box>
                  <Grid item xs={12}>
                    <Box mt={2}>
                      <Grid
                        container
                        alignItems="center"
                        justify="center"
                        spacing={1}
                      >
                        <Grid item>
                          <Typography>Not a member? </Typography>
                        </Grid>
                        <Grid
                          item
                          onClick={this.handleOpenLoginModal.bind(this)}
                        >
                          <Typography
                            color="primary"
                            className={classes.signuptext}
                          >
                            Sign up
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </React.Fragment>
              </SwipeableViews>
            </Grid>
            <Dialog
              id="delete-account-dialog"
              open={resetPasswordModalOpen}
              onClose={this.props.handleClose}
              disableAutoFocus={true}
              onBackdropClick={this.closeResetPasswordModal.bind(this)}
              PaperProps={{
                style: {
                  minWidth: '400px',
                  maxWidth: '400px',
                  padding: '20px'
                }
              }}
            >
              <Typography variant="h6" align="center">
                Enter the email for the account you want to reset
              </Typography>
              <div className={classes.resetContainer}>
                <TextField
                  id="mission"
                  name="mission"
                  variant="outlined"
                  value={this.state.resetEmail}
                  onChange={this.handleEmailChange.bind(this)}
                  error={this.state.resetEmailErrorText ? true : false}
                  helperText={this.state.resetEmailErrorText}
                  label="Email"
                  className={classes.emailField}
                />
                <Button
                  variant="outlined"
                  onClick={this.sendResetPasswordEmail.bind(this)}
                  fullWidth
                  className={classes.confirmResetButton}
                >
                  Send Password Reset Email
                </Button>
              </div>
            </Dialog>
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signIn: creds => dispatch(signIn(creds)),
    sendResetPasswordEmailHandler: email => dispatch(resetAccount(email)),
    openSignupModal: () => dispatch(openSignupModal())
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withFirebase,
  withFirestore,
  withStyles(styles)
)(SignIn);



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js